import { BillingApi, College } from '@api/model';
import { DefaultHttpService } from './HttpService';

class CollegeService {

  readonly defaultHttpService = new DefaultHttpService();

  readonly billingApi = new BillingApi(this.defaultHttpService);

  public verifyCollegeName(name: string, xGRecaptcha?: string): Promise<boolean> {
    return this.billingApi.verifyCollegeName(name, xGRecaptcha);
  }

  public getCollegeKey(): Promise<string> {
    return this.billingApi.getCollegeKey();
  }

  public createCollege(data: College): Promise<any> {
    return this.billingApi.createCollege(data);
  }
}

export default new CollegeService();
